import http from "./http-common";
import AboutUsModel from "../models/aboutUs";
import ContactUsModel from "../models/contactUs";
import StaffModel from "../models/staff";

// About Us APIs
// eslint-disable-next-line
export default new (class AboutUsService {
  // Get all about us
  async getContent() {
    return await http
      .get("/abouts?pLevel")
      .then(async (response) => {
        const data = await Promise.all(
          response.data.data.map((aboutUs) => AboutUsModel.get(aboutUs))
        );

        return data.sort((a, b) => a.order - b.order);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  // Get all contact us
  async getContact() {
    return await http
      .get("/about-contact-uses?pLevel")
      .then(async (response) => {
        const data = await Promise.all(
          response.data.data.map((contact) => ContactUsModel.get(contact))
        );

        return data.sort((a, b) => a.order - b.order);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  // Get all staff
  async getStaff() {
    // เดิม filter ด้วย id === 1 ซึ่งเป็น id ของฐานข้อมูลชุดเก่าเท่านั้น
    // ข้อมูลจริงใช้ id 4 / 7 -> filter ไม่เจอ แล้ว data[0] เป็น undefined
    // ใช้ค่า section แทน และเรียงตาม id เป็นตัวสำรอง
    return await http
      .get("/about-staffs?pLevel")
      .then(async (response) => {
        const rows = [...response.data.data].sort((a, b) => a.id - b.id);
        const match =
          rows.find((s) => String(s.section).toLowerCase() === "staff") ||
          rows[0];

        return match ? await StaffModel.get(match) : StaffModel.empty();
      })
      .catch((error) => {
        console.log(error);
        return StaffModel.empty();
      });
  }

  // Get all Doctor
  async getDoctor() {
    // section ที่ไม่ใช่ 'staff' คือกลุ่มที่สอง (ข้อมูลจริงตอนนี้คือ 'Vice President')
    return await http
      .get("/about-staffs?pLevel")
      .then(async (response) => {
        const rows = [...response.data.data].sort((a, b) => a.id - b.id);
        const match = rows.find(
          (s) => String(s.section).toLowerCase() !== "staff"
        );

        return match ? await StaffModel.get(match) : StaffModel.empty();
      })
      .catch((error) => {
        console.log(error);
        return StaffModel.empty();
      });
  }
})();
